export function requestScope(resolve) {
  const epochs = new Map();
  return name => {
    const identity = resolve();
    const epoch = (epochs.get(name) || 0) + 1;
    epochs.set(name, epoch);
    return () => identity === resolve() && epoch === epochs.get(name);
  };
}

export async function scopedResult(valid, promise) {
  const result = await promise;
  if (!valid()) {
    const error = new Error('Stale account response');
    error.name = 'AbortError';
    throw error;
  }
  return result;
}

// Capture the Vuex router object as well as account/user and list generation.
// An A→B→A transition creates another route object, so equality of account IDs
// alone cannot authorize an earlier response. Returning false never clears work.
export function conversationRequestScope({ state, rootState, rootGetters }) {
  const route = rootState?.route;
  const account = rootGetters?.getCurrentAccountId;
  const actor = rootGetters?.getCurrentUser?.id;
  const epoch = state?.requestEpoch || 0;
  const valid = route && Number.isSafeInteger(account) && account > 0 &&
    Number.isSafeInteger(actor) && actor > 0;
  return () => !!valid && rootState.route === route &&
    rootGetters.getCurrentAccountId === account && rootGetters.getCurrentUser?.id === actor &&
    (state.requestEpoch || 0) === epoch;
}

export function guardedConversationActions(actions) {
  return Object.fromEntries(Object.entries(actions).map(([name, action]) => {
    if (action.constructor.name !== 'AsyncFunction') return [name, action];
    return [name, async (context, ...arguments_) => {
      const current = conversationRequestScope(context);
      if (!current()) return;
      const guarded = {
        ...context,
        commit: (...values) => { if (current()) return context.commit(...values); },
        dispatch: (...values) => current() ? context.dispatch(...values) : Promise.resolve(),
      };
      return action(guarded, ...arguments_);
    }];
  }));
}
